import {
  type Either,
  isLeft,
  isRight,
  type Left,
  type Right,
} from 'fp-ts/Either';

export function isLeftResult<T extends Either<unknown, unknown>>(
  result: T,
): result is Extract<T, Left<unknown>> {
  return isLeft(result);
}

export function isRightResult<T extends Either<unknown, unknown>>(
  result: T,
): result is Extract<T, Right<unknown>> {
  return isRight(result);
}
